import styled, { css } from 'styled-components';
import { isGlobetrotter } from '../../utils/theming.js';
import mq from '../../utils/mediaQueries.js';

var sizes = {
  xxxs: '1rem',
  xxs: '1.2rem',
  xs: '1.6rem',
  s: '2.2rem',
  m: '3.2rem',
  l: '4.8rem',
  xl: '6.4rem'
};
var globeSizes = {
  xxxs: 1.2,
  xxs: 1.4,
  xs: 1.8,
  s: 2.4,
  m: 3.4,
  l: 5,
  xl: 6.6
};
var Icon = styled.svg.withConfig({
  displayName: "Iconstyle__Icon",
  componentId: "sc-14paivs-0"
})(["display:inline-block;height:2.2rem;width:2.2rem;", " ", " ", ""], function (_ref) {
  var $size = _ref.$size;
  return $size && css(["height:", ";width:", ";"], sizes[$size], sizes[$size]);
}, function (_ref2) {
  var $sizeMobile = _ref2.$sizeMobile;
  return $sizeMobile && css(["", ""], mq.sMax(css(["height:calc(", ");width:calc(", ");"], sizes[$sizeMobile], sizes[$sizeMobile])));
}, isGlobetrotter(css(["height:2.4rem;width:2.4rem;", " ", ""], function (_ref3) {
  var $size = _ref3.$size;
  return $size && css(["height:calc(", " + 0.2rem);width:calc(", " + 0.2rem);stroke-width:", "rem;"], sizes[$size], sizes[$size], 3.2 / globeSizes[$size] * 0.1);
}, function (_ref4) {
  var $sizeMobile = _ref4.$sizeMobile;
  return $sizeMobile && css(["", ""], mq.sMax(css(["height:calc(", " + 0.2rem);width:calc(", " + 0.2rem);stroke-width:", "rem;"], sizes[$sizeMobile], sizes[$sizeMobile], 3.2 / globeSizes[$sizeMobile] * 0.1)));
})));

export { Icon };
//# sourceMappingURL=Icon.style.js.map
